import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setLogin } from "../../store/features/loginSlice";
import localStorageService from "../../services/LocalStorageService";
import { getHeaders } from "../../constants/SidebarHeaders";

const Sidebar = () => {

  const dispatch = useDispatch();

  const [selectedHeader, setSelectedHeader] = useState(null);

  const headers = getHeaders();

  const onLogoutHandler = (e) => {
    localStorageService.clearStorage();
    dispatch(setLogin(false));
  };

  return (
    <>
      <ul
        className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
        id="accordionSidebar"
      >
        <a
          className="sidebar-brand d-flex align-items-center justify-content-center"
          href="index.html"
        >
          <div className="sidebar-brand-icon rotate-n-15">
            <i className="fas fa-laugh-wink" />
          </div>
          <div className="sidebar-brand-text mx-3">{process.env.REACT_APP_NAME}</div>
        </a>
        <hr className="sidebar-divider my-0" />
        {headers?.map((header, index) => {
          if (header?.show) {
            return (
              <li
                className={`nav-item ${selectedHeader === header.label ? 'active' : 'inactive'}`}
                key={index}
                onClick={() => {
                  header.label === "Logout" ? onLogoutHandler() :
                  setSelectedHeader(header.label);
                }}
              >
                <a className="nav-link" href={header?.link}>
                  <span>{header?.label}</span>
                </a>
              </li>
            );
          }
          return null;
        })}
      </ul>
    </>
  );
};

export default Sidebar;
